export default {
  UPDATE_INVESTOR_PAGES (state, pages) {
    state.investorPages = pages
    if (!state.investorPage && state.investorPages[0]) {
      state.investorPage = state.investorPages[0]
    }
  },
  ADD_INVESTOR_PAGE (state, page) {
    state.investorPage = page
  },
  UPDATE_INVESTOR_PAGE (state, updatedPage) {
    state.investorPage = updatedPage
  },
  LOAD_INVESTOR_PHOTO (state, page) {
    state.investorPage.photo = page.photo
  },
  LOAD_INVESTOR_ABOUT_PREVIEW (state, page) {
    state.investorPage.aboutVideoPreview = page.aboutVideoPreview
  },
  // advantages
  INVESTOR_PAGE_ADD_ADVANTAGE (state, advantage) {
    state.investorPage.advantages.push(advantage)
  },
  INVESTOR_PAGE_DELETE_ADVANTAGE (state, id) {
    state.investorPage.advantages = state.investorPage.advantages.filter(adv => adv.id !== id)
  },
  INVESTOR_PAGE_UPDATE_ADVANTAGE (state, {id, title, description, order}) {
    const advantage = state.investorPage.advantages.find(adv => adv.id === id)
    if (advantage) {
      Object.assign(advantage, { title, description, order })
    }
  },
  // potential users
  INVESTOR_PAGE_ADD_POTENTIAL_USER (state, user) {
    state.investorPage.potentialUsers.push(user)
  },
  INVESTOR_PAGE_DELETE_POTENTIAL_USER (state, id) {
    state.investorPage.potentialUsers = state.investorPage.potentialUsers.filter(user => user.id !== id)
  },
  INVESTOR_PAGE_UPDATE_POTENTIAL_USER (state, { id, title, lead, learnMoreLink, learnMoreTitle, order }) {
    const user = state.investorPage.potentialUsers.find(u => u.id === id)
    if (user) {
      Object.assign(user, { title, lead, learnMoreLink, learnMoreTitle, order })
    }
  },
  // reasons
  INVESTOR_PAGE_ADD_REASON (state, reason) {
    state.investorPage.reasons.push(reason)
  },
  INVESTOR_PAGE_DELETE_REASON (state, id) {
    state.investorPage.reasons = state.investorPage.reasons.filter(reason => reason.id !== id)
  },
  INVESTOR_PAGE_UPDATE_REASONS (state, { id, title, description, order }) {
    const reason = state.investorPage.reasons.find(r => r.id === id)
    if (reason) {
      Object.assign(reason, { title, description, order })
    }
  },
  // page itself
  DELETE_INVESTOR_PAGE (state, id) {
    state.investorPage = null
    state.investorPages = state.investorPages.filter(page => page.id !== id)
  },
  UPDATE_INVESTOR_PAGE_ITEM (state, updatedPage) {
    const page = state.investorPages.find(({id}) => id === updatedPage.id)
    if (page) {
      Object.assign(page, updatedPage)
    }
  },
  ADD_NEW_INVESTOR_PAGE (state) {
    const page = {
      id: 'new',
      title: '',
      description: '',
      photo: '',
      aboutTitle: '',
      aboutDescription: '',
      aboutVideoUrl: '',
      aboutVideoPreview: '',
      potentialusersTitle: '',
      advantagesTitle: '',
      ratesTitle: '',
      ratesFile: '',
      ratesDescription: '',
      ratesFileTitle: '',
      ratesIsConsultation: false,
      reasonsTitle: '',
      isHidden: true,
      isInvestorPage: false,
      potentialUsers: [],
      advantages: [],
      reasons: []
    }

    state.investorPages.push(page)
    state.investorPage = page
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations/investor.js